import apiService from "./apiService";

export const deliveryUser = (query) => {
  let queryParams = {
    word: query?.delivery,
    page: query?.page ?? 1,
    item_per_page: 10,
  }
  return apiService.get(URIS.delivery, {params: queryParams})
}

export const createDeliveryUser = (data) => {
  return apiService.post(URIS.delivery, data)
}

export const changesStatus = (payload) => {
  return apiService.patch(URIS_D("delivery_status", payload.id), {status: payload.status}
  )

}
const URIS = {
  delivery: '/admin/delivery-persons',
  search_api: '/admin/delivery-persons/search',

}

const URIS_D = (url, param1) => {
  return {
    delivery_status: `/admin/delivery-persons/${param1}`,

  }[url]
}

